export default "__VITE_ASSET__29698be5__"